import type { VenueClientModule } from "../types";
import { RaceHud } from "./RaceHud";
import { buildRaceTrack3d } from "./scene3d";

/** Townsy Downs on the client (ADR-0016): the racecourse, horses and tote board in 3D, and the betting overlay. */
export const raceTrackClient: VenueClientModule = {
  kind: "race_track",
  build3d: (ctx) => buildRaceTrack3d(ctx),
  Hud: RaceHud,
};
